<new-chart [chart]="this" [chart]="newChart" [language]="language"
  classes="border border-zen border-opacity-10 rounded w-full bg-white">
  @if ( (!export||singleExport) && !hideHeader) {
  <chart-header [legacyChart]="this" [chart]="newChart" [excelChartOptions]="{}" [language]="language"
    classes="border-b border-zen border-opacity-10 px-5 h-12">
    <div title class="flex flex-row items-center gap-2">
      <h4 class="text-zen">{{ dashlet?.Title }}</h4> <generation-info [language]="language"
        *ngIf="isGeneration && !export"></generation-info> <span class="text-app">{{selectedCriteria?.localisedTitle|
        extract:language}}</span>
    </div>
    <z-select options *ngIf="question?.canGroup" [DemoLimit]="DemoGroupingLimit" [options]="groupingOptions"
      [language]="language" [placeholder]="('txtSelectOption'| translate:language:ModuleNames.Shared)"
      [(ngModel)]="dashlet.SelectedGroupKey" (selectionChange)="selectedGroupingChanged($event)">
      <ng-template #valueTemplate let-value>
        {{ value?.name | extract : language }}
      </ng-template>
    </z-select>

  </chart-header>
  }

</new-chart>